export default __webpack_public_path__ + "static/media/result-figure-anthe.85f381ff.png";